// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import actions from '../../actions/searchBanner';
import type {State as ReduxState} from '../../reducers/index';
import type {State as SearchBannerState} from '../../reducers/searchBanner';
import {
    Content as UrgentMessageSearchBannerContent,
    Icon as UrgentMessageSearchBannerIcon
} from './urgentMessageContents';
import {
    Content as PercentBookedSearchBannerContent,
    Icon as PercentBookedSearchBannerIcon
} from './percentBookedContents';
import SearchBanner from './SearchBanner';

export const PERCENT_BOOK = 'PERCENT_BOOK';
export const URGENT_MESSAGE = 'URGENT_MESSAGE';

type SearchBannerPercentBook = {
    type: typeof PERCENT_BOOK,
    percentageLeft: number,
    location?: string
};

type SearchBannerUrgentMessage = {
    type: typeof URGENT_MESSAGE,
    countOfVisitors: number,
    location?: string
};

type SearchBannerUnknown = {
    type: string
};

export type SearchBannerData =
    | SearchBannerPercentBook
    | SearchBannerUrgentMessage
    | SearchBannerUnknown;

type StateProps = {
    q: string,
    searchBanner: SearchBannerState,
    isDatedSearch: boolean
};

type Props = {
    onHide: typeof actions.searchBannerAddLocation,
    bannerData: SearchBannerData,
    isDatedSearch: boolean
} & StateProps;

export class SearchBannerContainer extends Component<Props> {
    dismissBanner = () => {
        const {q, onHide} = this.props;
        onHide(q);
    };

    render() {
        const {isDatedSearch, bannerData, q, searchBanner} = this.props;

        if (q in searchBanner.dismissedLocations) {
            return null;
        }

        let content;
        let icon;

        switch (bannerData.type) {
            case PERCENT_BOOK:
                content = <PercentBookedSearchBannerContent {...bannerData} />;
                icon = <PercentBookedSearchBannerIcon />;
                break;
            case URGENT_MESSAGE:
                if (isDatedSearch) {
                    content = (
                        <UrgentMessageSearchBannerContent {...bannerData} />
                    );
                    icon = <UrgentMessageSearchBannerIcon />;
                }
                break;
            default:
                break;
        }

        return content ? (
            <SearchBanner icon={icon} onDismiss={this.dismissBanner}>
                {content}
            </SearchBanner>
        ) : null;
    }
}

const mapStateToProps = ({
    searchParams: {params},
    searchBanner
}: ReduxState): StateProps => {
    const q = params.q || '';
    const isDatedSearch = !!(params.arrival && params.departure);
    return {isDatedSearch, q, searchBanner};
};

const mapDispatchToProps = {
    onHide: actions.searchBannerAddLocation
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchBannerContainer);
